import oaRequest from '@/utils/oaRequest';

// 获取招聘岗位
export function getDemand(data) {
    return oaRequest({
        url: `/hrm/demand/list?pageNum=1&pageSize=10000`,
        method: 'post',
        data
    });
}